if(document.querySelector('.sh-yt__video-overlay')) {
    document.querySelector('.sh-yt__video-overlay').addEventListener('click', function H() {
        let __this = this;
        if(__this.parentNode.querySelector('.sh-yt__video-foreground').classList.contains('youtube-vid')) {
            let src = `https://www.youtube.com/embed/${__this.parentNode.querySelector('.youtube-vid').dataset.src}?autoplay=1;&feature=oembed&amp;controls=1&amp;hd=1&amp;autohide=1&amp;mute=0`;
            __this.parentNode.querySelector('.youtube-vid iframe').setAttribute('src', src);
        }
        setTimeout(() => {
            __this.style.display = 'none';
        }, 700);
    });
}
